import { render, staticRenderFns } from "./PerfilDados.vue?vue&type=template&id=0a136bc5&scoped=true"
import script from "./PerfilDados.vue?vue&type=script&lang=js"
export * from "./PerfilDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a136bc5",
  null
  
)

export default component.exports